import { Button, CircularProgress } from "@mui/material";

import payload from "@app/payload";
import Text from "@components/Text";
import { t } from "@i18n";
import { buildRenewalMessage } from "@checkout/lib/summary";
import { Autorenew } from "@mui/icons-material";

import './styles.scss';

export default function SubmitButton({
  valuesRef,
  onPress,
  loading,
  plan,
  disabled = false,
}: any) {
  const productName = payload.name || "";
  const submitText =
    valuesRef.current.method === "pix"
      ? t("checkout.submit.generatePix")
      : plan.interval === "lifetime"
        ? t("checkout.submit.buyLifetime", { productName })
        : t("checkout.submit.subscribe", { productName });
  const renewalText = buildRenewalMessage(plan);

  return (
    <>
      <Button
        className={`submit-button mt-4${loading ? ' submit-button--loading' : ''}`}
        onClick={onPress}
        disabled={loading || disabled}
      >
        {loading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <Text.span>{submitText}</Text.span>
        )}
      </Button>
      {renewalText && (
        <div className="checkout-renewal-note">
          <Autorenew fontSize="small"/>
          <Text.caption >{renewalText}</Text.caption>
        </div>
      )}
    </>
  );
}
